import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import BMAuditExportButton from "./BMAuditExportButton";
import { useAuth } from "@/hooks/useAuth";

const NAV_ITEMS = [
  { label: "Benchmark Top Level Summary", path: "/partner/benchmark-maintenance/summary" },
  { label: "Fund House BM Sector Mapping", path: "/partner/benchmark-maintenance/mapping" },
  { label: "Fund House BM Holdings", path: "/partner/benchmark-maintenance/holdings" },
];

export default function BenchmarkMaintenanceLayout() {
  const { hasRole } = useAuth();
  const navItems = hasRole(["superadmin"])
    ? [...NAV_ITEMS, { label: "Audit Trail", path: "/partner/benchmark-maintenance/audit" }]
    : NAV_ITEMS;
  const location = useLocation();
  return (
    <div className="min-h-screen">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-6 space-y-4">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h1 className="text-2xl font-bold">BM Fund House Updating</h1>
            <p className="text-muted-foreground text-sm">View fund house allocations per CBAM Investment Sector for each Benchmark.</p>
          </div>
          <BMAuditExportButton />
        </div>
        <div className="border-b">
          <nav className="flex items-center gap-1 overflow-x-auto -mb-px">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path || (location.pathname === "/partner/benchmark-maintenance" && item.path.endsWith("/summary"));
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={cn(
                    "px-4 py-2 text-sm border-b-2 transition-colors whitespace-nowrap",
                    isActive
                      ? "border-primary text-foreground font-medium"
                      : "border-transparent text-muted-foreground hover:text-foreground"
                  )}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
